import { render } from "./CustomComponent.vue?vue&type=template&id=3c9ff4f4&scoped=true"
import script from "./CustomComponent.vue?vue&type=script&lang=js"
export * from "./CustomComponent.vue?vue&type=script&lang=js"

import "./CustomComponent.vue?vue&type=style&index=0&id=3c9ff4f4&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9ff4f4"]])

export default __exports__